import React from "react";
import { Inline, Field, Stack, Card, CardContent, CardHeader, Divider, List, ListItem, ListItemIcon, ListItemText, Button, FormControlLabel, Checkbox} from "@digitalreality/ui";
import { useAppState } from "../../StateStore/Store";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import TextField from '@mui/material/TextField';
import { useState } from "react";

export default function ConXConnection({ onSubmit, formRef, editMode = true }: any) {
    const { t } = useTranslation();
    const { state, dispatch } = useAppState();


    const { control, formState: { errors }, unregister, register, setValue, handleSubmit } = useForm({
        defaultValues: state.projectModal.project,
        mode: "onBlur",
    });

  const [ignoreValidation, setIgnoreValidation] = useState(false);

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setIgnoreValidation(e.target.checked);
        if (isChecked) {
            unregister("conXProjectId"); // Remove validation
            setValue("conXProjectId", "");
        } else {
            register("conXProjectId", {
                required: "This field is required",
                maxLength: { value: 256, message: "Maximum length is 256 characters" },
            }); // Re-register field with validation
        }
    };

    return (
        <form
            id="licenseForm"
            onSubmit={handleSubmit(onSubmit)}
            ref={formRef}
            autoComplete="off">
            <Stack gap={5}>
                <Card sx={{ height: "538px", p: 0}}>
                    <CardHeader title="ConX Projects"/>
                    <Divider />
                    <CardContent sx={{ height: "490px", maxHeight: "490px", overflow: 'auto'}}>
                        <List>
                            <ListItem sx={{ paddingLeft: '0', paddingBottom: '20px'}}>
                                <ListItemText>{"Insert the Project ID of the ConX project that should be connected to this alpinePRO project. This connection has to be done manually on alpinePRO side. You will receive an email when the project is connected."}</ListItemText>
                            </ListItem>
                            <ListItem>
                                <Controller
                                    name="conXProjectId"
                                    control={control}
                                    rules={
                                        !ignoreValidation
                                            ? {
                                                required: t("Texts.ValidationRequired") as string,
                                                maxLength: { value: 256, message: t("Texts.LengthValidation") },
                                            }
                                            : 
                                            undefined // No validation when checkbox is checked
                                    }
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("ConX Project ID")}
                                            error={!!errors.conXProjectId}
                                            disabled={ignoreValidation}
                                            helperText={errors.conXProjectId?.message}
                                        />
                                    )}
                                />
                            </ListItem>

                            <ListItem>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                        checked={ignoreValidation}
                                        onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="I don't want to connect a ConX project"
                                />
                            </ListItem>

                        </List>
                    </CardContent>
                </Card>
            </Stack>
        </form>
    );
}
